/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as t from "react";
import s from "prop-types";
import { classNames as l } from "@progress/kendo-react-common";
const c = t.forwardRef(
  (e, m) => {
    const a = t.useRef(null), r = t.useRef(null), i = t.useCallback(() => {
      r.current && r.current.focus();
    }, [r]);
    return t.useImperativeHandle(a, () => ({
      element: r.current,
      focus: i,
      props: e
    })), t.useImperativeHandle(
      m,
      () => a.current
    ), /* @__PURE__ */ t.createElement(
      "li",
      {
        ref: r,
        id: e.id,
        style: e.style,
        className: l(
          "k-breadcrumb-item",
          {
            "k-breadcrumb-root-item": e.isFirstItem,
            "k-breadcrumb-last-item": e.isLastItem
          },
          e.className
        )
      },
      e.children
    );
  }
), n = {
  id: s.string,
  className: s.string,
  children: s.any,
  style: s.object
};
c.displayName = "KendoReactBreadcrumbListItem";
c.propTypes = n;
export {
  c as BreadcrumbListItem
};
